import React, { FC, useEffect } from 'react';
import { Icon, IconButton, IconButtonStyles, Icons, Tooltip } from '@silverfort/sf-components';
import { AD_ENTITY_TYPES, INSIGHT_STATUS_DESCRIPTIONS } from '@silverfort-nodelibs/common/utils/consts';
import ExplainabilityColumn from './ExplainabilityColumn';
import { InsightEntity } from '../../api/types/Insights';
import { getRiskIndicatorByRiskRule } from '@silverfort-nodelibs/common/utils/insight';
import { EXPLAINABILITY_SETTINGS_MAP } from './Explainability/ExplainabilitySettings';
import InvestigationDrawer from '../../../../components/InvestigationDrawer/InvestigationDrawer';
import { useAppDrawer } from '../../../../components/AppDrawer/AppDrawerProvider';

const getIconByEntityType = (entityType: string) => {
    switch (+entityType) {
        case AD_ENTITY_TYPES.SERVER:
            return Icons.Server;
        case AD_ENTITY_TYPES.USER:
            return Icons.User;
        default:
            return Icons.User;
    }
};

const IdentifierColumn: FC<Partial<InsightEntity & { isNew: boolean }>> = ({
    display_name,
    entity_type,
    status,
    isNew,
    guid,
    risk_rule
}) => {
    const entityIcon = getIconByEntityType(entity_type ?? '');
    const { closeAppDrawer, displayContent } = useAppDrawer();

    useEffect(() => {
        return closeAppDrawer();
    }, []);

    const onInvestigateClicked = () => {
        displayContent(<InvestigationDrawer guid={guid} identifier={display_name} adType={+(entity_type ?? '')} />);
    };

    const doesHaveReason =
        status !== INSIGHT_STATUS_DESCRIPTIONS.RESOLVED &&
        (!!getRiskIndicatorByRiskRule(risk_rule ?? '')?.reason || !!EXPLAINABILITY_SETTINGS_MAP[risk_rule ?? '']);

    return display_name && entity_type ? (
        <div className="h-full w-full flex flex-1 items-center gap-[8px]">
            <Icon icon={entityIcon} size={20} className="flex-none text-sf-gray-400" />
            <Tooltip title={display_name} onlyOnOverflow>
                <span className="w-[248px] text-13 text-gray-800 font-sf">{display_name}</span>
            </Tooltip>
            {isNew && (
                <div className="h-[24px] w-fit px-[8px] bg-sf-primary-100 rounded flex items-center justify-center">
                    <span className="text-12 text-sf-primary-500 font-sf font-medium">New</span>
                </div>
            )}
            <IconButton
                icon={Icons.Investigate}
                iconSize={20}
                className="invisible group-hover:visible"
                buttonStyle={IconButtonStyles.Secondary}
                onClick={onInvestigateClicked}
            />
            {doesHaveReason && (
                <ExplainabilityColumn guid={guid ?? ''} entityName={display_name} ruleName={risk_rule ?? ''} />
            )}
        </div>
    ) : null;
};

export default IdentifierColumn;
